import React from 'react';
import styled from '@emotion/styled';

import {
  AccessTime,
  DurationIconButton,
  DurationLight as DurationLightBase,
} from '~/src/components';
import { breakpoints } from '~/src/styles';
import { DurationIconButtonWrapper } from '~/src/templates/content/common';

export const DurationContainer = styled.div`
  grid-area: duration;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  ${breakpoints.minDesktop} {
    font-size: 16px;
  }
`;

export const DurationLight = styled(DurationLightBase)`
  ${breakpoints.minDesktop} {
    font-size: 16px !important;
  }
`;
interface Props {
  minutes: number | null;
}

export const Duration: React.FC<Props> = ({ minutes }) => {
  if (minutes === null) {
    return null;
  }

  return (
    <DurationContainer>
      <DurationIconButtonWrapper>
        <DurationIconButton size="medium" aria-label="approximate reading time">
          <AccessTime />
          <DurationLight>{`${minutes} min`}</DurationLight>
        </DurationIconButton>
      </DurationIconButtonWrapper>
    </DurationContainer>
  );
};
